import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import config from '../config';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await fetch(`${config.apiBaseURL}/api/auth/forgot-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    }).catch(() => {});
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Reset your password</h2>
        {sent ? (
          <div className="auth-success">
            <p>If an account exists for <strong>{email}</strong>, you'll receive a reset link shortly.</p>
            <p style={{ marginTop: 12 }}><Link to="/login">Back to sign in</Link></p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p className="auth-hint">Enter your email and we'll send you a link to reset your password.</p>
            <label>
              Email
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
            </label>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
            <p className="auth-switch" style={{ marginTop: 12 }}>
              <Link to="/login">Back to sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
